// extracted by mini-css-extract-plugin
export default {"input-service":"recommendMaster_input-service__BUheN","btn":"recommendMaster_btn__9M-BD","input":"recommendMaster_input__T5-ni","btn-modal":"recommendMaster_btn-modal__lf9il"};